import { GridColumns } from '@mui/x-data-grid';
import { useEffect, useState } from 'react';
import { IconButton } from '@mui/material';
import { Edit } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { Avatar, DataTable } from '../../components';
import MainContainer from '../../components/MainContainer';
import useStyles from './styles';
import ShopGroup from '../../entities/shop-group.entity';
import useShopGroups from '../../hooks/data/useShopGroups';
import { useFetch } from '../../hooks';
import { useShopGroupsContext } from '../../contexts/ShopGroupContext';

interface UpdateButtonProps {
  value: ShopGroup;
}

const UpdateButton = ({ value }: UpdateButtonProps): JSX.Element => {
  const { handleSelectShopGroup } = useShopGroupsContext();

  return (
    <IconButton onClick={() => handleSelectShopGroup(value)}>
      <Edit />
    </IconButton>
  );
};

const headers: GridColumns = [
  {
    field: 'imageUrl',
    headerName: '',
    disableColumnMenu: true,
    editable: false,
    disableExport: true,
    disableReorder: true,
    hideable: false,
    sortable: false,
    align: 'center',
    hideSortIcons: true,
    renderCell: (value) => <Avatar src={value.row.imageUrl} />,
  },
  { field: 'label', headerName: 'Grupo', editable: false, flex: 1 },
  {
    field: 'isDisabled',
    headerName: 'Status',
    editable: false,
    flex: 1,
    valueGetter: (params) => (params.row.isDisabled ? 'Desabilitado' : 'Habilitado'),
  },
  {
    field: 'action',
    headerName: 'Ações',
    disableColumnMenu: true,
    editable: false,
    disableExport: true,
    disableReorder: true,
    hideable: false,
    filterable: false,
    align: 'center',
    headerAlign: 'center',
    sortable: false,
    renderCell: (value) => <UpdateButton value={value.row} />,
    hideSortIcons: true,
  },
];

export const ShopGroups = (): JSX.Element => {
  const styles = useStyles();
  const history = useNavigate();
  const [shopGroup, setShopGroups] = useState<ShopGroup[]>([]);
  const repositoryShopGroups = useShopGroups();
  const { data: dataShopGroup, loading } = useFetch(repositoryShopGroups.fetchAll);

  useEffect(() => {
    if (dataShopGroup) {
      setShopGroups(dataShopGroup);
    }
  }, [dataShopGroup]);

  if (loading) {
    return <></>;
  }

  return (
    <MainContainer>
      <>
        <div className={styles.content}>
          <DataTable
            columns={headers}
            rows={shopGroup || []}
            loading={loading}
            showAddButton
            onClickAdd={() => history('/shop-groups/new')}
          />
        </div>
      </>
    </MainContainer>
  );
};

export default ShopGroups;
